import { useState } from "react";
import { Copy, Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export const RecoveryCodes = (props) => {
  const { codes, email, onDone } = props;
  const [saved, setSaved] = useState(false);
  const text = `Prithira Global admin recovery codes for ${email}\nEach code works once. Keep them private.\n\n${codes.join("\n")}\n`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Recovery codes copied");
    } catch {
      toast.error("Copy failed. Write the codes down instead.");
    }
  };
  const download = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
    a.download = "prithira-admin-recovery-codes.txt";
    a.click();
  };

  return (
    <div className="space-y-4" data-testid="recovery-codes-panel">
      <p className="text-sm text-stone-600">
        If you lose your phone, each code below lets you sign in once instead of the 6-digit app code. They are shown <b>only now</b>. Store them in a password manager or print them.
      </p>
      <pre className="columns-2 font-mono text-sm leading-7 bg-stone-50 rounded-lg p-4" data-testid="recovery-codes-list">{codes.join("\n")}</pre>
      <div className="flex gap-2">
        <Button type="button" variant="outline" size="sm" onClick={copy} data-testid="recovery-codes-copy-btn"><Copy className="h-4 w-4 mr-1" />Copy</Button>
        <Button type="button" variant="outline" size="sm" onClick={download} data-testid="recovery-codes-download-btn"><Download className="h-4 w-4 mr-1" />Download .txt</Button>
      </div>
      <label className="flex items-center gap-2 text-sm text-stone-700">
        <Checkbox checked={saved} onCheckedChange={(v) => setSaved(!!v)} data-testid="recovery-codes-saved-checkbox" />
        I have saved these codes somewhere private
      </label>
      <Button className="w-full rounded-full" disabled={!saved} onClick={onDone} data-testid="recovery-codes-done-btn">{props.doneLabel}</Button>
    </div>
  );
};
